var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWheel = function SvgWheel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 34963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4882",
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "#4D5967"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 34961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 396",
    d: "M39 22C39 24.9972 38.2076 27.9411 36.7031 30.5334C35.1986 33.1256 33.0355 35.274 30.4331 36.7608L22 22H39Z",
    fill: "#08F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 397",
    d: "M30.5 36.7224C27.9043 38.221 24.9586 39.0068 21.9614 39C18.9642 38.9932 16.0221 38.1941 13.4333 36.6837L22 22L30.5 36.7224Z",
    fill: "#517AAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 398",
    d: "M13.5 36.7224C10.9043 35.2238 8.75103 33.0656 7.25832 30.4666C5.76562 27.8675 4.98658 24.92 5.00017 21.9229L22 22L13.5 36.7224Z",
    fill: "#FF5368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 399",
    d: "M13.5 7.27757C16.0957 5.77897 19.0414 4.99324 22.0386 5.00004C25.0358 5.00684 27.9779 5.80592 30.5667 7.31628L22 22L13.5 7.27757Z",
    fill: "#FFCF5D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 400",
    d: "M5 22C5 19.0028 5.7924 16.0589 7.29689 13.4666C8.80137 10.8744 10.9645 8.72597 13.5669 7.23916L22 22L5 22Z",
    fill: "#FF983B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 401",
    d: "M30.5 7.27756C33.0956 8.77616 35.249 10.9344 36.7417 13.5334C38.2344 16.1325 39.0134 19.0799 38.9998 22.0771L22 22L30.5 7.27756Z",
    fill: "#4EE267"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 92",
    d: "M22.8658 9.5C22.4809 10.1667 21.5186 10.1667 21.1337 9.5L17.6696 3.5C17.2847 2.83333 17.7659 2 18.5357 2L25.4639 2C26.2337 2 26.7148 2.83333 26.3299 3.5L22.8658 9.5Z",
    fill: "#4D5967"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wheel.6e718c53.svg";
export { ForwardRef as ReactComponent };